<template>
  <LoaderSpinner v-if="flagLoading" />

  <!-- Report selector (solo visible en /reports) -->
  <MainReports v-if="!activeReport" />

  <!-- Dynamic report display -->
  <component
    v-else
    :is="activeReportComponent"
    :filters="activeFilters"
  />
</template>

<script>
import LoaderSpinner from "@/components/CircularLoader.vue";
import MainReports from "@/components/Reports/ReportsMain.vue";
import WorkedHoursReport from "@/components/Reports/WorkedHoursReport.vue";

import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";

export default {
  components: {
    LoaderSpinner,
    MainReports,
    WorkedHoursReport,
  },
  setup() {
    const route = useRoute();
    const flagLoading = ref(true);

    // Tipo de reporte activo (solo existe si vienes de /reports/:type/results)
    const activeReport = computed(() => route.params.type || null);

    // Filtros que llegan vía query
    const activeFilters = computed(() => {
      return route.query.filters ? JSON.parse(route.query.filters) : {};
    });

    // Determina qué componente cargar
    const activeReportComponent = computed(() => {
      switch (activeReport.value) {
        case "hours":
          return WorkedHoursReport;
        // case "timesheets": return TimesheetsReport;
        // case "clients": return ClientsReport;
        default:
          return null;
      }
    });

    onMounted(() => {
      flagLoading.value = false;
    });

    return {
      flagLoading,
      activeReport,
      activeFilters,
      activeReportComponent,
    };
  },
};
</script>
